import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from '@/components/common/Toaster';
import { SeasonalAlertBanner } from '@/components/common/SeasonalAlertBanner';
import { LanguageProvider } from '@/context/LanguageContext';

export const Layout = () => (
  <LanguageProvider>
    <div className="min-h-screen flex flex-col bg-cream">
      <SeasonalAlertBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster />
    </div>
  </LanguageProvider>
);
